import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getHistoryLog = createAsyncThunk('/logdata/content', async (nopage) => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/log_verifikasi/${userId}?page=${nopage}`, {})
    return response.data;
})

export const logdataSlice = createSlice({
    name: 'historylog',
    initialState: {
        isLoading: false,
        historylog : []
    },
    reducers: {


        addNewHistorylog: (state, action) => {
            let {newHistorylogObj} = action.payload
            state.historylog = [...state.historylog, newHistorylogObj]
        },

        deleteHistorylog: (state, action) => {
            let {index} = action.payload
            state.historylog.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getHistoryLog.pending]: state => {
			state.isLoading = true
		},
        [getHistoryLog.fulfilled]: (state, action) => {
            state.historylog = action.payload.data
			state.isLoading = false
		},
        [getHistoryLog.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getHistoryLog.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getHistoryLog.fulfilled, (state, action) => {
            state.historylog = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getHistoryLog.rejected, (state) => {
            state.isLoading = false;
          });
      },
})

export const { addNewHistoryaudit, deleteHistoryaudit } = logdataSlice.actions

export default logdataSlice.reducer